import(/* webpackMode: "eager" */ "/app/apps/ashtrom-ashcrete/app/[locale]/not-found.tsx");
